import { styled } from '@mui/material';

export const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  whitespace: nowrap;
  width: 1;
`;

export const FileInputField = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const FileInputContainer = styled('form')`
  max-width: 36rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1.25)};
  margin-top: ${({ theme }) => theme.spacing(1.25)};
`;
